module.exports = __webpack_public_path__ + "img/account-m3.b00e7236.png";